/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Rules_DescInputs */



/**
* | output |
* | --- |
* | "All of these can still be changed after the tournament exists." |
*
* @param {Tournament_Wiz_Rules_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_rules_desc = /** @type {((inputs?: Tournament_Wiz_Rules_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Rules_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout cela reste modifiable une fois le tournoi créé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todo esto se puede cambiar después de crear el torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tudo isso ainda pode ser alterado depois que o torneio existir.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Puoi ancora cambiare tutto dopo aver creato il torneo.")
	return /** @type {LocalizedString} */ ("All of these can still be changed after the tournament exists.")
});